import React from 'react';
import ButtonDropdownCommon from 'components/Buttons/ButtonDropdown';
import { cn } from 'helpers/css';
/**
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {{ disabled: boolean, onClick: () => void, name: string, divider: boolean }[]} props.listDropDownItem
 * @param {string} props.className
 * @param {string} props.classNameDropdownMenu
 * @param {boolean} props.disabled
 * @param {string} props.color
 * @param {"destructive" | "outline" | "secondary" | "ghost" | "link"} props.variant
 * @returns
 */
const ButtonDropDown = ({ className, ...props }) => {
  return (
    <ButtonDropdownCommon className={cn('component:ButtonDropdownCommon', className)} {...props} />
  );
};

export default ButtonDropDown;
